import { StockStatus } from "../../../../../../apps/services/warehouse-service/src/app/stock/dto/stock-status.enum";

export class StockOutResponseDto {
    stockId: number;
    lotNo: string;
    soNumber: string;
    rackPosition: string;
    quantity: number;
    totalCartons: number;
    totalPouches: number;
    loosePouches: number;
    pouchWeight: number;
    pallet: string;
    coldStorage: string;
    packingCompleted: string;
    palletCode:number;
    stockLocationId:number;
    productName : string;
    variantCode : string;
    stockType?: StockStatus
    uomId?:number
    constructor(stockId: number,lotNo: string,soNumber: string,rackPosition: string,quantity: number,totalCartons: number,totalPouches: number,loosePouches: number,pouchWeight: number,pallet:string,coldStorage: string,packingCompleted: string,palletCode:number,stockLocationId:number,productName?:string,variantCode?:string,stockType?:StockStatus,uomId?:number){
        this.stockId = stockId;
        this.lotNo = lotNo;
        this.soNumber = soNumber;
        this.rackPosition = rackPosition;
        this.quantity = quantity;
        this.totalCartons = totalCartons;
        this.totalPouches = totalPouches;
        this.loosePouches = loosePouches;
        this.pouchWeight = pouchWeight;
        this.pallet = pallet;
        this.coldStorage = coldStorage;
        this.packingCompleted = packingCompleted;
        this.palletCode = palletCode;
        this.stockLocationId=stockLocationId;
        this.productName = productName;
        this.variantCode = variantCode;
        this.stockType = stockType
        this.uomId = uomId
    }
}